import http from 'utils/http';

export const checkLocationIsSupported = ({
  merchantId, addressId, lat, lng,
}) => http
  .get(`v1/organizations/{{organizationId}}/merchants/${merchantId}/supported-location/?${addressId ? `address=${addressId}` : `latitude=${lat}&longitude=${lng}`}`)
  .then((res) => res.data);
